<template>
<div>
    <div class="breadcrumb-list">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active">Profile</li>
        </ol>
        <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
            <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create New Employee</button>
        </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeData"></employee-sidebar>

    <div class="emplyee-info-wrp">
        <div class="employment-details">
            <div class="col-3">
              <date-picker
                  v-model="range"
                  lang="en"
                  format="YYYY-MM-DD"
                  range
                  type="date"
                  width="400"
                  @change="filterLocationByDate($event)"
                >
                </date-picker>
          </div>
            <div id="mapp"></div>
      </div>
        </div>
        <createEmployeeModal></createEmployeeModal>
    </div>
</div>
</template>

<script>
import createEmployeeModal from "../Employees/createEmployeeModal";
import employeeSidebar from "../Employees/employeeSidebar";
import DatePicker from 'vue2-datepicker';
import moment from "moment";
export default {
  name: "userProfile",
  components: {
    createEmployeeModal,
    employeeSidebar,
    DatePicker
  },
  data() {
    return {
      employeeData          :[],
      markers               :[],
      selectedCompany       : this.$store.getters.getSelectedCompany,
      currency              :this.$store.getters.getSelectedCompany.currency,
      map                   :null,
      allLocations          :[],
      range                 :[new Date(),new Date()],
      markersPathAttaching  : '',
      user                  :this.$store.getters.getUser,
    };
  },
  mounted() {
    this.getEmployeeData();
    this.initMap();
  },
  methods: {
    loadMarkers() {
      let map                   = this.map;
      const inImage             = require('@/assets/images/in_unselected.svg');
      const inImageSelected     = require('@/assets/images/in_selected.svg');
      let markersArr            = [];
      var flightPlanCoordinates = [];
      this.allLocations.forEach(function (loc) {
        let myLatLng = {
          lat: parseFloat(loc.latitude),
            lng: parseFloat(loc.longitude)
          };
          flightPlanCoordinates.push(new google.maps.LatLng(loc.latitude, loc.longitude))
          let marker = new google.maps.Marker({
            position: myLatLng,
            map,
            icon:(loc.text=='In')? inImage:inImageSelected,
            animation: google.maps.Animation.DROP
          });
          markersArr.push(marker);
          const infoWindow = new google.maps.InfoWindow();
          marker.addListener("click", () => {
            marker.setIcon(inImageSelected);
            var  label='';
            if(loc.text=='in'){
              var  label='Punch-in';
            }
            if(loc.text=='out'){
              var  label='Punch-out';
            }
            let text = '<div style="text-align: left !important;"> <strong>' + label + ' Time</strong><br>'+moment(loc.created_at).format('h:mm:ss a')+'<br>';
            text += '</div>';
            infoWindow.setContent(text);
            infoWindow.open(marker.getMap(), marker);
          });
          google.maps.event.addListener(infoWindow,'closeclick',function(){
            marker.setIcon(inImage);
          });
      });
      this.markersPathAttaching = new google.maps.Polygon({
        path          : flightPlanCoordinates,
        strokeColor   : "#00779C",
        strokeOpacity : 1.0,
        strokeWeight  :4,
        geodesic: true,
            icons: [{
                icon: {path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW},
                offset: '100%',
                repeat: '70px'
            }]
      });
      this.markersPathAttaching.setMap(map);
      this.markers = markersArr;
    },
    filterLocationByDate(){
      this.clearMarkers();
      this.$axios({
        method  : "post",
        data  : {
          company_id  : this.selectedCompany.id,
          employee_id : this.employeeData.id,
          date        : [moment(this.range[0]).format("YYYY-MM-DD"),moment(this.range[1]).format("YYYY-MM-DD")]
        },
        url     : this.$FilterEmployeesLocations,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.allLocations = res.data.result;
          this.loadMarkers();
        }
      });
    },
    clearMarkers() {
      this.markers.forEach(function (mkr) {
        mkr.setMap(null);
      });
      this.markersPathAttaching.setMap(null);
    },
    getEmployeeLocations(){
      this.$axios({
        method  : "get",
        params  : {
          company_id  : this.selectedCompany.id,
          employee_id : this.employeeData.id,
        },
        url     : this.$GetEmployeesLocations,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.allLocations = res.data.result;
          console.log(this.allLocations,'loc')
          this.loadMarkers();
        }
      });
    },
    initMap() {
      let companyLatLong = (this.selectedCompany.locations)?this.selectedCompany.locations[0]:null;
      const myLatLng = {
        lat: (companyLatLong) ? parseFloat(companyLatLong.lat) : 31.5198893,
        lng: (companyLatLong) ? parseFloat(companyLatLong.lng) : 74.3508756
      };
      this.map = new google.maps.Map(document.getElementById("mapp"), {
        zoom: 14,
        center: myLatLng,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              { visibility: "off" },
            ]
          }
        ]
      });
    },
    getEmployeeData() {
      var id = this.$route.params.id;
      this.$axios({
        method: "get",
        params: {
          user_id: id,
          company_id: this.selectedCompany.id,
        },
        url: this.$GetEmployeeProfile,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.employeeData = res.data.result[0];
          this.$store.commit("setEmployeeProfileId", this.employeeData);
          this.getEmployeeLocations();
        }
      });
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}
#mapp{
  height: 550px !important;
}

</style>
